import { defineStore } from 'pinia';
import {Activity, ServiceSettings} from '@/models/settings';

export const useServicesActivityStore = defineStore('servicesActivity', {
    state: () => ({
        activities: [{
            id: 'act-10',
            read: false,
            serviceId: "chat",
            message: "New group created: Call for additional drivers today",
            category: "Chat - New group",
            timestamp: "07/01/2026, 14:01:27"
        },
        {
            id: 'act-9',
            read: false,
            serviceId: "suite",
            message: "You are short of drivers today",
            category: "System - Alert",
            timestamp: "07/01/2026, 14:00:27"
        },
        {
            id: 'act-8',
            read: false,
            serviceId: "suite",
            message: "12 orders waiting more than 15 mins for dispatch",
            category: "System - Alert",
            timestamp: "07/01/2026, 13:50:27"
        },
        {
            id: 'act-7',
            read: true,
            serviceId: "chat",
            message: "Store 556- Manhattan leaders: Jane Fonda- Hi Nick, Let's get together today",
            category: "Chat",
            timestamp: "06/30/2026, 17:15:27"
        },
        {
            id: 'act-6',
            read: true,
            serviceId: "suite",
            message: "Supervisor's store leaders: Chris robin- Hey Nick, welcome and good luck",
            category: "Chat",
            timestamp: "06/30/2026, 17:15:27"
        },
        {
            id: 'act-5',
            read: true,
            serviceId: "chat",
            message: "You've been added to a new group: Supervisor's store leaders",
            category: "Chat - New group",
            timestamp: "06/29/2026, 17:15:27"
        },
        {
            id: 'act-4',
            read: true,
            serviceId: "chat",
            message: "You've been added to a new group: Store 556- Manhattan leaders",
            category: "Chat - New group",
            timestamp: "06/29/2026, 17:15:27"
        },
        {
            id: 'act-3',
            read: true,
            serviceId: "chat",
            message: "You've been added to a new group: Store 556- Manhattan team",
            category: "Chat - New group",
            timestamp: "06/29/2026, 17:15:27"
        },
        {
            id: 'act-2',
            read: true,
            serviceId: "suite",
            message: "Welcome to Heila Suite!",
            category: "System",
            timestamp: "06/29/2026, 17:15:27"
        }] as Array<Activity>,
    }),
    getters: {
        lastActivities: (state): Activity[] => {
            return state.activities.slice(-10);
        },
        unreadCount: (state): number => {
            return state.activities.filter(a => !a.read).length;
        }
    },
    actions: {
        addLastActivity(activity: Activity) {

        },
        markAllAsRead() {
            this.activities.forEach(a => a.read = true);
        },
        markAsRead(id: string) {
            const index = this.activities.findIndex(a => a.id === id)
            if (index >= 0 && this.activities[index]) this.activities[index].read = true;
        }
    }
});